import Link from 'next/link';
import React from 'react';
import { IButtonLinkProps } from './_props';

interface Props extends Pick<IButtonLinkProps, 'prefetch' | 'href' | 'useNextLink'> {
  children: React.ReactElement<React.AnchorHTMLAttributes<HTMLAnchorElement>>;
}

export default function LinkWrapper({ useNextLink, prefetch, href, children }: Props) {
  if (!useNextLink) {
    return React.cloneElement(children, { href });
  }

  const { children: anchorChildren, ...anchorProps } = children.props;

  return (
    <Link prefetch={prefetch} href={href} {...anchorProps}>
      {anchorChildren}
    </Link>
  );
}
